"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var BannerWithSwitchVip_1 = __importDefault(require("./BannerWithSwitchVip"));
var Info_1 = __importDefault(require("./Info"));
var PaymentSystems_1 = __importDefault(require("./PaymentSystems"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var MainBanner = function (_a) {
    var Banner = _a.Banner, Button = _a.Button, Search = _a.Search, hideSwitch = _a.hideSwitch;
    var t = (0, next_intl_1.useTranslations)('translation');
    var isAuthorized = (0, swr_hooks_1.useIsAuthorized)();
    var userType = (0, swr_hooks_1.useUserType)().userType;
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var config = (0, swr_hooks_1.useConfig)();
    var localStyles = (0, react_1.useMemo)(function () {
        if (!!Banner)
            return {};
        if (Object.keys(breakpoints).length === 0)
            return {};
        var backgroundImage;
        switch (userType) {
            case swr_hooks_1.USER_TYPES.VIP:
                backgroundImage = !breakpoints.mobile
                    ? '/img/home-blocks/main-banner/main-banner-bg-vip.jpg'
                    : '/img/home-blocks/main-banner/main-banner-bg-sm-vip.jpg';
                break;
            default:
                backgroundImage = !breakpoints.mobile
                    ? '/img/home-blocks/main-banner/main-banner-bg.jpg'
                    : '/img/home-blocks/main-banner/main-banner-bg-sm.jpg';
        }
        return { backgroundImage: "url(".concat(backgroundImage, ")") };
    }, [userType, Banner, breakpoints]);
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container, " ").concat(userType === swr_hooks_1.USER_TYPES.VIP
            ? styles_module_scss_1.default.vipContainer
            : styles_module_scss_1.default.defaultContainer), style: localStyles },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.promo }, Banner ? react_1.default.createElement(Banner, null) : react_1.default.createElement(BannerWithSwitchVip_1.default, { hideSwitch: hideSwitch })),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonAndInfo },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonWrapper },
                Button ? react_1.default.createElement(Button, null) : null,
                !isAuthorized && Banner && (react_1.default.createElement("div", { className: styles_module_scss_1.default.underButtonText }, t('registrationJustTakesAMinute')))),
            !(config === null || config === void 0 ? void 0 : config.hideMainBannerInfo) ? (react_1.default.createElement("div", { className: styles_module_scss_1.default.info },
                react_1.default.createElement(PaymentSystems_1.default, null),
                react_1.default.createElement(Info_1.default, null))) : null),
        Search ? react_1.default.createElement(Search, null) : null));
};
exports.default = MainBanner;
